@if (loadingSpinnerService.isSpinnerVisible()) {
  <vwui-spinner class="vwui-spinner--with-margin"></vwui-spinner>
}

@if (!quickscanSubmitted()) {
  <div class="main-wrapper">
    @if (!mandateDetails?.preconditions?.quickscanNotFilledIn.satisfiedOrOptional) {
      <app-explanation [link]="getUriForStep(2)">{{ 'COMPONENT.mandating.cannot_start.quickscan_not_filled' | translate }}</app-explanation>
    }
    @if (!mandateDetails?.preconditions?.quickscanNotSubmitted.satisfiedOrOptional) {
      <app-explanation [link]="getUriForStep(2)">{{ 'COMPONENT.mandating.cannot_start.project_not_classified' | translate }}</app-explanation>
    }
  </div>
}

@if (!loadingSpinnerService.isSpinnerVisible() && quickscanSubmitted()) {
  <div>
    <app-scroll-navigation [navItems]="navItems"></app-scroll-navigation>
    <div class="tis-quickscan">
      <app-quickscan-list
        [projectDetails]="projectDetails"
        [quickscanDefinition]="quickscanDefinition"
        [quickscanAnswers]="projectDetails.tisQuickscanAnswers"
        [categoryInfo]="projectDetails.categoryInfo"
        [disabled]="!canEditTisQuickscan()"
        (projectDetailsChanged)="projectDetailsChanged.emit($event)"
        [tis]="true"
      ></app-quickscan-list>
      <app-project-quickscan-result
        class="align-left"
        [projectDetails]="projectDetails"
        (projectDetailsChanged)="projectDetailsChanged.emit($event)"
        [disabled]="!canEditTisQuickscan()"
        [tis]="true"
      ></app-project-quickscan-result>
    </div>
  </div>
}
